module.exports = __webpack_public_path__ + "static/img/B (27).c842bc20.png";